import { Box, Stack, useTheme } from '@mui/material';
import { useWindowSize } from '../../hooks/useWindowSize/useWindowSize';
import { Success as SuccessIcon } from '../../icons/Success/Success';
import { centerText16pxMarginSx, containerSx } from '../../styles/Global.style';
import { HelperLink } from '../HelperLink/HelperLink';
import { Heading } from '../Heading/Heading';
import { helperLinkTextSx, successContentSx } from './Success.style';

export const Success = ({ title, to, textIdentifier, linkText, onClick }) => {
  const theme = useTheme();
  const { windowSize } = useWindowSize();
  const color = theme.palette.secondary.main;

  return (
    <Stack component="section" sx={containerSx(windowSize.appInnerHeight)}>
      <Box sx={successContentSx}>
        <SuccessIcon />
        <Heading text={title} level={4} color={color} />
        <HelperLink
          to={to}
          textIdentifier={textIdentifier}
          linkText={linkText}
          sx={{ ...helperLinkTextSx, ...centerText16pxMarginSx }}
          onClick={onClick}
        />
      </Box>
    </Stack>
  );
};
